import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import FMPHeadline from '../../components/ui/FMPHeadline';
import Button from '@material-ui/core/Button';
import Search from '@material-ui/icons/Search';
import StationInvoicesContainer from '../../containers/accounting/StationInvoices';
import BulkInvoicesContainer from '../../containers/accounting/BulkInvoices';
import BulkCustomersContainer from '../../containers/logistics/BulkCustomers';
import StationsContainer from '../../containers/Stations';
import CarriersContainer from '../../containers/logistics/Carriers';
import TerminalsContainer from '../../containers/logistics/Terminals';
import SuppliersContainer from '../../containers/logistics/Suppliers';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import EnhancedTableHead from '../../components/EnhancedTableHead';

import FMPDatePicker from '../../components/pureForm/FMPDatePicker';
import FMPSectionHeader from '../../components/ui/FMPSectionHeader';

import { getDocuments } from './general';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormComponent from '../../components/FormComponent';
import { post } from '../../modules/utility';
import DownloadIcon from '@material-ui/icons/CloudDownload';

import InvoiceDocumentIcon from '../../components/ui/invoiceDocumentIcon';
import InvoiceDocumentPopup from '../../components/Dialogs/InvoiceDocumentPopup';
import ViewRackTransferLogDialog from '../../components/Dialogs/ViewRackTransferLogDialog';

import { getSharedStyles } from '../../themes';
import AuthUserContainer from '../../containers/AuthUser';
import { PureRecordRow, sortTable } from '../../libs/utility';
const isLocalhost = Boolean(window.location.hostname === 'localhost');

const statusToDisplay = {
	pending: 'Pending',
	complete: 'Complete',
	invalid: 'Invalid',
};

// Create our number formatter.
const moneyFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	minimumFractionDigits: 2,
	// the default value for minimumFractionDigits depends on the currency
	// and is usually already 2
});

const statusClassNames = {
	pending: {
		fontWeight: 900,
		color: '#2196F3',
	},
	error: {
		fontWeight: 900,
		color: '#FF500F',
	},
	sent: {
		fontWeight: 900,
		color: '#FF500F',
	},
	cancelled: {
		fontWeight: 900,
		color: '#FF500F',
	},
	invalid: {
		fontWeight: 900,
		color: '#FF500F',
	},
	pendingVeryOld: {
		fontWeight: 900,
		color: '#FF500F',
	},
	pendingOld: {
		fontWeight: 900,
		color: '#FF9800',
	},
	normal: {
		color: '#616161',
		fontWeight: 900,
	},
	complete: {
		fontWeight: 900,
		color: '#4CAF50',
	},
	paid: {
		fontWeight: 900,
		color: '#4CAF50',
	},
};
const styles = (theme) => ({
	...getSharedStyles(theme),
	...statusClassNames,
	paper: {
		width: '100%',
		overflowX: 'auto',
		textAlign: 'left',
		boxSizing: 'border-box',
		padding: 25,
		paddingBottom: 30,
		marginTop: 10,
		[theme.breakpoints.up('md')]: {
			padding: '30px 40px 40px 40px',
		},
	},
	row: {
		cursor: 'pointer',
	},
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	stats: {
		padding: '20px 10px 20px 10px',
		borderBottom: '1px solid #ddd',
		marginBottom: 10,
	},
	statGroup: {
		padding: '5px 5px 10px 5px',
		borderBottom: '1px solid #eee',
		marginBottom: 10,
	},
	available: {
		fontWeight: 900,
	},
	invoiceDocument: {
		position: 'absolute',
	},
	invoiceDocumentContainer: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
	},
	bigButton: {
		borderRadius: '100px',
		padding: '18px 34px',
		fontSize: 16,
	},
	smallButton: {
		borderRadius: '100px',
		fontWeight: 200,
	},
	pickPlease: {
		background: '#F7F7F7',
		border: '1px solid #DDDDDD',
		padding: 20,
		color: '#666',
	},
	divider: {
		borderBottom: '1px dashed #dddddd',
		marginBottom: 25,
		marginTop: 25,
	},
	dateRange: {
		marginRight: 10,
	},
	icon: {
		marginRight: 5,
	},
	resultsHere: {
		padding: 30,
		backgroundColor: '#f1f1f1',
		color: '#777',
		borderRadius: 10,
	},
	runningSearch: {
		paddingLeft: 5,
		display: 'flex',
		alignItems: 'center',
		fontSize: 16,
		color: '#666',
	},
});

class RackTransferSearch extends FormComponent {
	constructor(props) {
		super(props);

		const dateRange = 'lastMonth';
		const { afterDate, beforeDate } = this.dateRangeToDates(dateRange);
		this.state = {
			formFieldError: {},
			dateRange,
			afterDate,
			beforeDate,
			order: 'desc',
			orderBy: 'rackTransferId',
			isSearching: false,

			isViewDialogOpen: false,
			viewRackTransfer: undefined,
			isInvoiceDocumentPopupOpen: false,
			invoiceDocumentsPoppedUp: [],
		};
	}

	componentDidMount() {}

	getApiParams = () => {
		const { accessToken } = this.props;

		const { afterDate, beforeDate } = this.state;

		const afterMoment = moment(afterDate);
		const beforeMoment = moment(beforeDate);

		const params = {
			accessToken,
			afterDate: afterMoment.format('YYYY-MM-DD'),
			beforeDate: beforeMoment.format('YYYY-MM-DD'),
		};
		return params;
	};

	submitSearch = () => {
		const {
			// advancedSearchDeliveries,
			showErrors,
		} = this.props;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		const { afterDate, beforeDate } = this.state;

		const afterMoment = moment(afterDate);
		const beforeMoment = moment(beforeDate);

		if (afterMoment.isAfter(beforeMoment)) {
			formFieldError.afterDate = `Before date can't be before after date. Time is not a circle man.`;
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		this.setState({
			isSearching: true,
		});

		const params = this.getApiParams();
		post({
			method: 'rackTransfer.advancedSearch',
			params,
			callback: (err, apiSearchResult) => {
				this.setState({ isSearching: false });
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}

				try {
					this.formatSearchResults(apiSearchResult);
				} catch (e) {
					console.error(e);
					throw e;
				}
			},
		});
	};

	getDocumentInfo = (uploadedInvoiceDocuments) => {
		const { classes, resourceMap } = this.props;

		if (_.isEmpty(uploadedInvoiceDocuments)) {
			return 'None yet';
		}

		//- Documents
		let left = 0;
		let zIndex = 100;
		return (
			<div
				className={classes.invoiceDocumentContainer}
				onClick={() => {
					this.onDocumentClick(uploadedInvoiceDocuments);
				}}
			>
				{uploadedInvoiceDocuments.map((invoiceDocument, i) => {
					left = i * 10;
					zIndex--;
					return (
						<div className={classes.invoiceDocument} style={{ left, zIndex }} key={i}>
							<InvoiceDocumentIcon
								hasTooltip={false}
								invoiceDocument={invoiceDocument}
								resourceMap={resourceMap}
								onClick={_.noop}
							/>
						</div>
					);
				})}
			</div>
		);
	};

	formatSearchResults = (apiSearchResult) => {
		const { collections } = apiSearchResult;

		const {
			rackTransferCollection,
			bulkCustomerCollection,
			carrierCollection,
			invoiceDocumentCollection,
			bulkDeliveryCollection,
			terminalCollection,
			supplierCollection,
			resourceCollection,
		} = collections;

		const bulkCustomerLookup = _.keyBy(bulkCustomerCollection, 'bulkCustomerId');
		const carrierLookup = _.keyBy(carrierCollection, 'carrierId');
		const invoiceDocumentLookup = _.keyBy(invoiceDocumentCollection, 'invoiceDocumentId');
		const bulkDeliveryLookup = _.keyBy(bulkDeliveryCollection, 'bulkDeliveryId');
		const terminalLookup = _.keyBy(terminalCollection, 'terminalId');
		const supplierLookup = _.keyBy(supplierCollection, 'supplierId');
		const resourceLookup = _.keyBy(resourceCollection, 'resourceId');

		const rackTransferRows = rackTransferCollection.map((rackTransfer) => {
			let {
				rackTransferId,
				linkedBulkDeliveryId,
				bulkCustomerId,
				status,
				invoiceDocumentIds,
				loadingNumber,
				carrierId,
			} = rackTransfer;

			const bulkCustomer = bulkCustomerLookup[bulkCustomerId] || {
				number: '',
				name: 'Missing bulk customer',
			};
			const bulkCustomerDisplay = `${bulkCustomer.name}`;

			//- Delivery
			const bulkDelivery = bulkDeliveryLookup[linkedBulkDeliveryId];
			let deliveryInfo = <span>Delivery {linkedBulkDeliveryId} not found</span>;
			if (bulkDelivery) {
				const { deliveryDate, bulkDeliveryId } = bulkDelivery;

				const dateDisplay = moment(deliveryDate).format('ddd, M/D');
				deliveryInfo = (
					<Fragment>
						<div>{bulkCustomerDisplay}</div>
						<div>Delivery #{bulkDeliveryId}</div>
						<div>{dateDisplay}</div>
					</Fragment>
				);
				if (!carrierId) {
					carrierId = bulkDelivery.carrierId;
				}
				if (!loadingNumber) {
					loadingNumber = bulkDelivery.loadingNumber;
				}
			}

			//- Rack Transfer
			const invoiceDocuments = invoiceDocumentIds.map((invoiceDocumentId) => {
				return invoiceDocumentLookup[invoiceDocumentId] || { name: 'MISSING' };
			});

			const { uploadedInvoiceDocuments, missingInvoiceDocuments } = getDocuments({
				bulkDelivery,
				carrierMap: carrierLookup,
				terminalMap: terminalLookup,
				supplierMap: supplierLookup,
				invoiceDocuments,
				isRackTransfer: true,
			});

			let fuelInfo = null;
			const carrier = carrierLookup[carrierId] || { name: `MISSING CARRIER: ${carrierId}` };
			if (!_.isEmpty(_.filter(missingInvoiceDocuments, { isRequired: true }))) {
				fuelInfo = (
					<Fragment>
						<div>{carrier.name}</div>
						<div>No documents yet.</div>
					</Fragment>
				);
			} else {
				const {
					pickupTerminalId,
					offloadTerminalId,
					pickupNetGallons,
					offloadNetGallons,
				} = rackTransfer;

				const pickupTerminal = terminalLookup[pickupTerminalId] || {
					name: `Missing terminal : ${pickupTerminalId}`,
				};

				const offloadTerminal = terminalLookup[offloadTerminalId] || {
					name: `Missing terminal : ${offloadTerminalId}`,
				};

				fuelInfo = (
					<Fragment>
						<div>{carrier.name}</div>
						<div>
							Pickup : {pickupNetGallons} from {pickupTerminal.name}
						</div>
						<div>
							Offload : {offloadNetGallons} to {offloadTerminal.name}
						</div>
					</Fragment>
				);
			}

			//- Documents
			let documentInfo = this.getDocumentInfo(uploadedInvoiceDocuments);
			const statusDisplay = statusToDisplay[status] || status;

			let invoiceTotal = <span>{moneyFormatter.format(rackTransfer.total)}</span>;
			return {
				rackTransferId,
				deliveryInfo,
				invoiceTotal,
				fuelInfo,
				loadingNumber,
				documentInfo,
				linkedBulkDeliveryId,
				bulkCustomerId,
				carrierId,
				status,
				statusDisplay,
				rowClick: () => {
					this.handleRowClick(rackTransferId);
				},
			};
		});
		this.setState({ rackTransferRows, resourceLookup });
	};

	handleCloseViewDialog = () => {
		this.setState({
			isViewDialogOpen: false,
			viewRackTransfer: undefined,
		});
	};

	handleCloseInvoiceDocumentPopup = () => {
		this.setState({
			isInvoiceDocumentPopupOpen: false,
			invoiceDocumentsPoppedUp: [],
		});
	};

	onDocumentClick = (invoiceDocuments) => {
		this.setState({
			isInvoiceDocumentPopupOpen: true,
			invoiceDocumentsPoppedUp: invoiceDocuments,
		});
	};

	handleEdit = (rackTransferId) => {
		this.props.history.push(`/accounting/rackTransfer/update/${rackTransferId}`);
	};

	handleRowClick = (rackTransferId) => {
		const { rackTransferRows } = this.state;
		const viewRackTransfer = _.find(rackTransferRows, { rackTransferId });
		this.setState({
			viewRackTransfer,
			isViewDialogOpen: true,
		});
	};

	render() {
		return (
			<Grid container spacing={2}>
				<Grid item md={12} xs={12}>
					{this.renderSearch()}
				</Grid>
				<Grid item md={12} xs={12}>
					{this.renderResults()}
				</Grid>
			</Grid>
		);
	}

	renderSearch() {
		const { classes } = this.props;
		const { resourceLookup } = this.state;

		return (
			<>
				<FMPHeadline label="Rack Transfer Search" />
				<Paper className={classes.paper}>
					<Grid container spacing={2}>
						{this.renderDateRangeOptions()}
						{this.renderSubmitButtons()}
					</Grid>

					<InvoiceDocumentPopup
						open={this.state.isInvoiceDocumentPopupOpen}
						onClose={this.handleCloseInvoiceDocumentPopup}
						invoiceDocuments={this.state.invoiceDocumentsPoppedUp}
						resourceMap={resourceLookup}
					/>

					<ViewRackTransferLogDialog
						open={this.state.isViewDialogOpen}
						onClose={this.handleCloseViewDialog}
						rackTransfer={this.state.viewRackTransfer}
						history={this.props.history}
					/>
				</Paper>
			</>
		);
	}

	componentDidUpdate(prevProps, prevState) {
		const { order, orderBy } = this.state;

		const newState = {};

		if (prevState.order !== order || prevState.orderBy !== orderBy) {
			newState.rackTransferRows = sortTable({
				data: this.state.rackTransferRows,
				order: order,
				orderBy: orderBy,
			});
		}

		//- Type to search needs to filter
		if (prevState.search !== this.state.search) {
			newState.filterMap = this.getFilterMap();
		}

		if (!_.isEmpty(_.keys(newState))) {
			this.setState(newState);
		}
	}

	handleSort = (orderBy) => {
		let order = 'desc';
		if (this.state.orderBy === orderBy && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	};

	renderResults() {
		const { classes, canMakeUpdates } = this.props;
		const { rackTransferRows, order, orderBy } = this.state;

		const completeColumns = [
			{
				id: 'rackTransferId',
				label: 'Rack Transfer #',
			},
			{
				id: 'deliveryInfo',
				label: 'Delivery Info',
			},
			{
				id: 'fuelInfo',
				label: 'Fuel Info',
			},
			{
				id: 'loadingNumber',
				label: 'Loading #',
			},
			{
				id: 'documentInfo',
				label: 'Documents',
			},
			{
				id: 'status',
				label: 'Status',
			},
			{
				id: 'edit',
				label: 'Edit',
				style: { textAlign: 'center' },
				isNotSortable: true,
			},
		];

		if (_.isEmpty(rackTransferRows)) {
			return (
				<Paper className={classes.paper} style={{ marginTop: 20 }}>
					<div className={classes.resultsHere}>Results here</div>
				</Paper>
			);
		}

		return (
			<Paper className={classes.paper} style={{ marginTop: 20 }}>
				<Table size="small" className={classes.table}>
					<EnhancedTableHead
						columnData={completeColumns}
						order={order}
						orderBy={orderBy}
						onRequestSort={this.handleSort}
					/>
					<TableBody>
						{rackTransferRows.map((row) => {
							return (
								<PureRecordRow hover className={classes.row} key={row.rackTransferId}>
									<TableCell onClick={row.rowClick}>{row.rackTransferId}</TableCell>
									<TableCell onClick={row.rowClick}>{row.deliveryInfo}</TableCell>
									<TableCell onClick={row.rowClick}>{row.fuelInfo}</TableCell>
									<TableCell onClick={row.rowClick}>{row.loadingNumber}</TableCell>
									<TableCell>{row.documentInfo}</TableCell>
									<TableCell
										onClick={row.rowClick}
										className={classes[row.status]}
										style={{ whiteSpace: 'nowrap' }}
									>
										{row.statusDisplay}
									</TableCell>

									{canMakeUpdates && (
										<TableCell style={{ whiteSpace: 'nowrap' }}>
											<Button
												className={classes.button}
												onClick={() => this.handleEdit(row.rackTransferId)}
											>
												Edit
											</Button>
										</TableCell>
									)}
								</PureRecordRow>
							);
						})}
					</TableBody>
				</Table>
			</Paper>
		);
	}

	copyTableToClipboard = () => {
		this.copyElementToClipboard('tableForCopy');
	};
	copyElementToClipboard = (elementId) => {
		const text = document.getElementById(elementId);
		text.style.display = 'table';
		let range;
		let selection;

		if (document.body.createTextRange) {
			range = document.body.createTextRange();
			range.moveToElementText(text);
			range.select();
		} else if (window.getSelection) {
			selection = window.getSelection();
			range = document.createRange();
			range.selectNodeContents(text);
			selection.removeAllRanges();
			selection.addRange(range);
		}
		document.execCommand('copy');
		window.getSelection().removeAllRanges();
		text.style.display = 'none';
		// document.getElementById("btn").value="Copied";

		const { deliveryInvoiceRows } = this.state;
		this.setState({
			snackbarMessage: `Copied ${deliveryInvoiceRows.length} rows to the clipboard`,
			snackbarIsOpen: true,
		});
	};

	setDateRange = (dateRange) => {
		const { afterDate, beforeDate } = this.dateRangeToDates(dateRange);
		if (!afterDate) {
			this.setState({ dateRange });
		} else {
			this.setState({ dateRange, afterDate, beforeDate });
		}
	};

	dateRangeToDates = (dateRange) => {
		if (dateRange === 'today') {
			return {
				afterDate: moment().format('YYYY-MM-DD'),
				beforeDate: moment().format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'todayTo30DaysOut') {
			return {
				afterDate: moment().format('YYYY-MM-DD'),
				beforeDate: moment().add(30, 'days').format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'thisMonthUpToToday') {
			return {
				afterDate: moment().startOf('month').format('YYYY-MM-DD'),
				beforeDate: moment().format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'thisMonthUpToEnd') {
			return {
				afterDate: moment().startOf('month').format('YYYY-MM-DD'),
				beforeDate: moment().endOf('month').format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'last7Days') {
			return {
				afterDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
				beforeDate: moment().format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'last60Days') {
			return {
				afterDate: moment().subtract(60, 'days').format('YYYY-MM-DD'),
				beforeDate: moment().format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'next7Days') {
			return {
				afterDate: moment().format('YYYY-MM-DD'),
				beforeDate: moment().add(7, 'days').format('YYYY-MM-DD'),
			};
		} else if (dateRange === 'lastMonth') {
			return {
				afterDate: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
				beforeDate: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
			};
		} else {
			return {};
		}
	};

	renderDateButton = (label, range) => {
		const { classes } = this.props;
		const { dateRange } = this.state;

		const variant = dateRange === range ? 'contained' : 'outlined';

		return (
			<Button
				className={classes.dateRange}
				variant={variant}
				color="primary"
				onClick={() => {
					this.setDateRange(range);
				}}
			>
				{label}
			</Button>
		);
	};
	renderDateRangeOptions = () => {
		const { dateRange } = this.state;
		let disabled = true;
		if (dateRange === 'custom') {
			disabled = false;
		}

		return (
			<>
				<Grid item md={12}>
					<FMPSectionHeader label={'Date Range'} isTop={true} />
				</Grid>

				<Grid item md={12} style={{ display: 'flex' }}>
					{this.renderDateButton('This Month', 'thisMonthUpToToday')}
					{this.renderDateButton('Last Month', 'lastMonth')}
					{this.renderDateButton('Last 60 days', 'last60Days')}
					{this.renderDateButton('Custom', 'custom')}
				</Grid>

				<FMPDatePicker
					{...this.setForm('afterDate', 'Delivery Date After', true)}
					format={'MMMM Do, YYYY'}
					md={5}
					disabled={disabled}
				/>

				<FMPDatePicker
					{...this.setForm('beforeDate', 'Delivery Date Before', true)}
					format={'MMMM Do, YYYY'}
					md={5}
					disabled={disabled}
				/>
			</>
		);
	};

	renderSubmitButtons = () => {
		const { classes } = this.props;
		const { isSearching } = this.state;

		const params = this.getApiParams();
		params.downloadCsv = true;
		const request = {
			method: 'rackTransfer.advancedSearch',
			params,
		};

		let host = '';
		if (isLocalhost) {
			host = 'http://localhost:3700';
		}
		const downloadUrl = `${host}/api?request=${JSON.stringify(request)}`;

		return (
			<Grid container spacing={2}>
				<Grid item md={12} style={{ paddingTop: 25, display: 'flex' }}>
					<Button
						className={classes.bigButton}
						variant="contained"
						color="primary"
						onClick={this.submitSearch}
						disabled={isSearching}
					>
						<Search className={classes.icon} />
						Rack Transfer Search
					</Button>

					<a
						href={downloadUrl}
						style={{ textDecoration: 'none', paddingRight: 5 }}
						target="_blank"
						rel="noreferrer noopener"
					>
						<Button
							className={classes.bigButton}
							variant="contained"
							color="primary"
							style={{ marginLeft: 10 }}
							disabled={isSearching}
						>
							<DownloadIcon className={classes.icon} />
							Search & Download
						</Button>
					</a>

					{isSearching && (
						<div className={classes.runningSearch}>
							<CircularProgress />
							<span style={{ paddingLeft: 5 }}>Searching...</span>
						</div>
					)}
				</Grid>
			</Grid>
		);
	};
}

RackTransferSearch.propTypes = {
	classes: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object,
	canMakeUpdates: PropTypes.bool,

	bulkCustomers: PropTypes.array,
	searchBulkCustomers: PropTypes.func.isRequired,

	advancedSearchStationInvoices: PropTypes.func.isRequired,
	advancedSearchBulkInvoices: PropTypes.func.isRequired,

	stations: PropTypes.array,
	searchStations: PropTypes.func.isRequired,

	carriers: PropTypes.array,
	searchCarriers: PropTypes.func.isRequired,

	terminals: PropTypes.array,
	searchTerminals: PropTypes.func.isRequired,

	suppliers: PropTypes.array,
	searchSuppliers: PropTypes.func.isRequired,

	accessToken: PropTypes.string,
};

export default _.flow([
	withStyles(styles),
	StationInvoicesContainer,
	BulkInvoicesContainer,
	BulkCustomersContainer,
	StationsContainer,
	CarriersContainer,
	TerminalsContainer,
	SuppliersContainer,
	AuthUserContainer,
])(RackTransferSearch);
